import { useContext } from 'react';
import { createContext } from 'react';

import { NewsletterInputNameProps } from '../@types/NewsletterInputNameProps';

export const NewsletterInputNameContext = createContext<NewsletterInputNameProps>({} as NewsletterInputNameProps);

NewsletterInputNameContext.displayName = 'NewsletterInputName';

const NewsletterInputnameProvider = (props: NewsletterInputNameProps) => (
	<NewsletterInputNameContext.Provider value={props}>{props.children}</NewsletterInputNameContext.Provider>
);

export const useNewsletterInputName = () => {
	const context = useContext(NewsletterInputNameContext);

	return context;
};

export default NewsletterInputnameProvider;
